<script>
import _ from "lodash";
export default {
  name: "QuantityControl",
  props: {
    item: {type: Object, required: true},
    quantity: {type: Number, required: false, default: 1},
    addToOrderAuto: {type: Boolean, required: false, default: true},
    manualInput: {type: Boolean, required: false, default: true},
    iconSize: { type: Number,default: 16 },
    fontSize: { type: Number, default: 14},
    btnSize: {type: Number, default: 32},
    backgroundColor: {type: String, default: "#d3d3d342"},
    disabled: { type: Boolean, default: false },

  },
  data() {
    return {
      localQuantity: this.quantity ?? 1,
    };
  },
  watch: {
    quantity(newVal) {
      this.localQuantity = newVal;
    },

    localQuantity:function(newVal) {
      this.$emit("displayTrash",newVal == null || newVal == 0 );
    },
  },

  created() {
    this.onManualInputDebounced = _.debounce(this.onManualInput, 300)
  },

  methods: {
    onManualInput() {

      if (this.localQuantity === "") {
        return
      }

      const value = Number(this.localQuantity)

      if (isNaN(value)) {
        return
      }

      if (value === 0) {
        this.localQuantity = 1
      } else {
        this.localQuantity = value
      }

      if (this.localQuantity < 1) {
        return
      }

      const qte = this.localQuantity - this.quantity

      if (!this.addToOrderAuto && !this.disabled) {
        this.$emit("updateQuantity", this.localQuantity)
        return
      }

      this.$store.dispatch("cart/addToOrder", [
        { menuItemId: this.item.id, quantity: qte, note: this.item.note },
      ])
    },

    increaseQuantity() {
      if(!this.disabled){
        this.localQuantity++;
      }

      if(!this.addToOrderAuto){
        this.$emit("updateQuantity", this.localQuantity);
        return
      }
      this.$store.dispatch("cart/addToOrder", [{ menuItemId: this.item.id, quantity: 1, note:this.item.note },]);
    },

    decreaseQuantity() {
      if(this.disabled){
        return
      }
      if (this.localQuantity > 1) {
            this.localQuantity--;

              if(!this.addToOrderAuto){
                this.$emit("updateQuantity", this.localQuantity);
                return
              }

            this.$store.dispatch("cart/addToOrder", [{ menuItemId: this.item.id, quantity: -1, note:this.item.note  }, ]);

      } else {
        this.$store.dispatch("cart/removeFromOrder", this.item.orderLineId);
      }
    },

    removeItem() {
      if(this.disabled){
        return
      }
        this.$store.dispatch("cart/removeFromOrder", this.item.orderLineId);
    },
  },
};
</script>

<template>
  <div
    class="d-flex align-items-center"
    :style="{
      borderRadius: '25px',
      backgroundColor: this.backgroundColor
    }"
  >
    <div
      class="d-flex justify-content-center align-items-center quantity-btn text-white"
      :style="{ width: btnSize + 'px', height: btnSize + 'px'}"
    >
      <span v-if="localQuantity > 1">
        <img
          alt="minus"
          :width="iconSize"
          :height="iconSize"
          src="@/assets/icons/minus-p.svg"
          @click="decreaseQuantity"
        />
      </span>
      <img
        v-else-if="addToOrderAuto"
        alt="trash"
        :width="iconSize"
        :height="iconSize"
        src="@/assets/icons/trash-p.svg"
        @click="removeItem"
      />
      <img
        v-else
        alt="trash"
        :width="iconSize"
        :height="iconSize" style="opacity:0.3"
         src="@/assets/icons/minus-p.svg"
      />
    </div>

    <input v-if="manualInput"
      type="number"
      min="1"
      v-model.number="localQuantity"
      @input="onManualInputDebounced"
      class="mx-1 mr-2 "
      :style="{
        width: '45px',
        textAlign: 'center',
        border: '0px solid #ccc',
        borderRadius: '6px',
        fontSize: fontSize + 'px'
      }"
    />

    <span v-else
      class="mx-1 mr-2 font-weight-bold text-dark"
      :style="{ fontSize: fontSize + 'px' }">
        {{localQuantity }}
    </span>

    <div
      class="d-flex justify-content-center align-items-center quantity-btn text-white"
      :style="{ width: btnSize + 'px', height: btnSize + 'px'}"
      @click="increaseQuantity"
    >
      <img alt="add" :width="iconSize" :height="iconSize" src="@/assets/icons/add-p.svg"/>
    </div>
  </div>
</template>

<style scoped>
.quantity-btn {
  border-radius: 50%;
  cursor: pointer;
}
</style>
